import styled from 'styled-components';

export const AdditionalLocationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  & > div:last-child {
    align-self: flex-end;
  }

  .ant-btn {
    padding: 0;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;

  .ant-form-item {
    width: 100%;
  }

  & > div:last-child {
    margin-left: 16px;
    margin-top: 9px;
    cursor: pointer;
  }
`;
